import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import React from "react";

const CourseRegister = [
  [
    "Course Register",
    "/admin/register/course",
    // "/admin/register/course/detail",

    <AppRegistrationIcon
      sx={{ fontSize: "2rem", ml: "0.3rem" }}
    ></AppRegistrationIcon>,
  ],
];

export default CourseRegister;
